var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 249,
    viewBox: "0 0 726 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_376_508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 726,
    height: 249
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.369 68.782C234.984 56.3931 220.992 75.4163 220.992 97.5284C172.701 34.5079 114.589 88.6839 126.866 163.866C110.496 163.866 100.674 173.817 102.311 204.775C89.58 209.553 81.465 213.128 77.7565 226.887C40.3887 227.172 20.1789 228.215 0 249L726 244.577C714.541 222.465 696.534 224.677 639.24 222.465C631.869 209.79 626.008 205.785 611.411 205.88C605.245 189.472 598.926 190.015 586.857 193.718C573.761 171.606 560.665 164.972 536.11 189.296C532.837 178.24 527.107 171.606 515.648 180.451C503.371 122.958 468.994 105.268 420.704 140.648C420.704 106.374 396.149 80.9445 370.776 101.951C370.53 86.9849 368.364 81.2396 355.224 83.1552C374.05 -15.2454 257.006 -34.0412 255.369 68.782Z",
    fill: "#FAFAFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_376_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.369 68.782C234.984 56.3931 220.992 75.4163 220.992 97.5284C172.701 34.5079 114.589 88.6839 126.866 163.866C110.496 163.866 100.674 173.817 102.311 204.775C89.58 209.553 81.465 213.128 77.7565 226.887C40.3887 227.172 20.1789 228.215 0 249L726 244.577C714.541 222.465 696.534 224.677 639.24 222.465C631.869 209.79 626.008 205.785 611.411 205.88C605.245 189.472 598.926 190.015 586.857 193.718C573.761 171.606 560.665 164.972 536.11 189.296C532.837 178.24 527.107 171.606 515.648 180.451C503.371 122.958 468.994 105.268 420.704 140.648C420.704 106.374 396.149 80.9445 370.776 101.951C370.53 86.9849 368.364 81.2396 355.224 83.1552C374.05 -15.2454 257.006 -34.0412 255.369 68.782Z",
    fill: "#FAFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M255.626 150.195C236.926 141.822 224.091 154.678 224.091 169.622C179.792 127.031 126.483 163.645 137.746 214.456C122.729 214.456 113.719 221.181 115.221 242.103C103.542 245.333 96.0976 247.749 92.6957 257.048C58.4168 257.24 39.8776 257.945 21.3667 271.992L687.354 269.003C676.842 254.059 660.324 255.553 607.766 254.059C601.004 245.492 595.627 242.786 582.238 242.85C576.581 231.761 570.785 232.128 559.713 234.631C547.699 219.687 535.686 215.203 513.161 231.642C510.158 224.17 504.902 219.687 494.39 225.664C483.128 186.809 451.593 174.853 407.294 198.764C407.294 175.6 384.769 158.414 361.493 172.611C361.268 162.497 359.281 158.614 347.227 159.908C364.497 93.4059 257.128 80.703 255.626 150.195Z",
    fill: "#30B8EE",
    fillOpacity: 0.39
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudbot);
export default __webpack_public_path__ + "static/media/cloudbot.092531ba4721b3e99a216b5a7a2a445e.svg";
export { ForwardRef as ReactComponent };